module.exports = __webpack_public_path__ + "media/images/logo-red-9b6ed39fe55c9c1c8732942d8927da67.png";